<script>
export default {
  props: {
    isVisible: {type: Boolean, default: false },
    title: {type: String,mdefault: ''},
    content: { type: String,default: ''},
    backgroundColor: {type: String,default: '#124c3d'}
  },
  computed: {
    modalHeight(){
      return (window.innerHeight - 140) + "px";
    },
    textColor() {
      // Check if background is light colored
      const lightColors = ['#c5e0f1', '#e0d9bd', '#f4e76e', '#f25c43'];
      return lightColors.includes(this.backgroundColor) ? '#063227' : 'white';
    },
    headingColor() {
      const lightColors = ['#c5e0f1', '#e0d9bd', '#f4e76e', '#f25c43'];
      return lightColors.includes(this.backgroundColor) ? '#063227' : '#e0d9bd';
    },
    textBackgroundColor() {
      const lightColors = ['#c5e0f1', '#e0d9bd', '#f4e76e', '#f25c43'];
      return lightColors.includes(this.backgroundColor) ? 'rgba(6, 50, 39, 0.08)' : 'rgba(255, 255, 255, 0.08)';
    },
    shouldShowBackgroundImage() {
      // Only show background image on dark colors that need it
      return this.backgroundColor === '#124c3d';
    },
    borderColor() {
      // Adjust border color based on background
      if (this.backgroundColor === '#c5e0f1') return '#063227';
      if (this.backgroundColor === '#e0d9bd') return '#063227';
      if (this.backgroundColor === '#f4e76e') return '#063227';
      if (this.backgroundColor === '#f25c43') return '#063227'; // Dark border for red background
      return '#f25c43';
    },
    accentColor() {
      // Use border color for accents (underline, border-left)
      // Special case for red background - use dark color for consistency
      if (this.backgroundColor === '#f25c43') {
        return '#063227';
      }
      return this.borderColor;
    }
  },
  methods: {
    closeModal() {
      this.$emit('close');
    }
  }
}
</script>
<template>
  <div v-if="isVisible" class="sale-info-modal-overlay" @click.self="closeModal">
    <div class="sale-info-modal-content" :class="{ 'show-bg-image': shouldShowBackgroundImage }" :style="{ backgroundColor: backgroundColor, borderColor: borderColor, height: modalHeight }">
      <button class="close-button" @click="closeModal">X</button>
      <h2 :style="{ color: headingColor }" class="modal-heading">{{ title }}</h2>
      <p :style="{ color: textColor, background: textBackgroundColor, borderLeftColor: accentColor }" class="modal-text">{{ content }}</p>
    </div>
  </div>
</template>

<style scoped>
.sale-info-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(18, 76, 61, 0.9);
  backdrop-filter: blur(5px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  animation: fadeIn 0.3s ease-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes slideIn {
  from {
    transform: translateY(20px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

.sale-info-modal-content {
  background: #124c3d;
  padding: 40px;
  border-radius: 30px;
  width: 85%;
  max-width: 650px;
  position: relative;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
  color: white;
  border: 3px solid #f25c43;
  animation: slideIn 0.3s ease-out;
  overflow: hidden;
  margin-top: 20px;
  display: flex;
  flex-direction: column;
}

.sale-info-modal-content.show-bg-image {
  background-image: url('@/assets/imgs/sale/dotted_sweden.png');
  background-repeat: no-repeat;
  background-size: 50%;
  background-position: top right;
}

.close-button {
  position: absolute;
  top: 15px;
  right: 20px;
  background: #f25c43;
  border: 2px solid #f25c43;
  font-size: 16px;
  cursor: pointer;
  color: white;
  border-radius: 31px;
  width: 35px;
  height: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: "Poppins", sans-serif;
  font-weight: 500;
  transition: all 0.2s ease;
  z-index: 10;
}

.close-button:hover {
  background: white;
  color: #f25c43;
  border-color: white;
}

.modal-heading {
  font-family: "Barlow Condensed", serif;
  font-weight: 700;
  font-style: normal;
  font-size: 3vw;
  margin-bottom: 25px;
  text-transform: none;
  position: relative;
  z-index: 2;
}

.modal-heading::after {
  content: '';
  position: absolute;
  bottom: -8px;
  left: 0;
  width: 50px;
  height: 3px;
  background: currentColor;
  border-radius: 2px;
  opacity: 0.7;
}

.modal-text {
  font-weight: 400;
  font-size: clamp(16px, 1.3vw, 30px);
  line-height: 1.6;
  padding: 20px;
  border-radius: 15px;
  border-left: 3px solid;
  flex: 1; 
  overflow-y: auto;
}

.modal-text::-webkit-scrollbar {
  width: 14px;        
}

.modal-text::-webkit-scrollbar-track {
  background: transparent; 
}

.modal-text::-webkit-scrollbar-thumb {
  background-color: #888;  
  border-radius: 7px;     
}

/* Responsive adjustments for smaller screens */
@media (max-width: 800px) {
  .sale-info-modal-content {
    width: 95%;
    padding: 30px 25px;
    margin: 0px 4px 0px 4px;

  }
  
  .sale-info-modal-content.show-bg-image {
    background-size: 80%;
  }
  
  .close-button {
    top: 15px;
    right: 15px;
    width: 35px;
    height: 35px;
    font-size: 16px;
  }
  
  .modal-heading {
    font-size: 6vw;
    margin-bottom: 20px;
  }
  
  .modal-text {
    font-size: 3.2vw;
    padding: 20px;
    line-height: 1.6;
  }
}

@media (max-width: 480px) {
  .sale-info-modal-content {
    width: 98%;
    padding: 25px 20px;
    border-radius: 20px;
  }
  
  .modal-heading {
    font-size: 7vw;
  }
  
  .modal-text {
    font-size: 4vw;
    padding: 15px;
  }
}
</style>
